define([], function () {
    "use strict";

	return new function () {
        /**
         * @param {*} buffer 
         * @returns base64Url encoded string
         */
        this.encodeBase64Url = function (buffer) {
            return window.btoa(Array.from(new Uint8Array(buffer), b => String.fromCharCode(b)).join(''))
                .replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=+$/, '');
        };
    
        /**
         * @param {*} base64Url
         * @returns ArrayBuffer
         */
        this.decodeBase64Url = function (base64Url) {
            const m = base64Url.length % 4;
            return Uint8Array.from(window.atob(
                base64Url.replace(/-/g, '+')
                    .replace(/_/g, '/')
                    .padEnd(base64Url.length + (m === 0 ? 0 : 4 - m), '=')
            ), c => c.charCodeAt(0)).buffer
        };

        /**
         * @param {*} base64 
         * @returns ArrayBuffer 
         */
		this.decodeBase64 = function(base64) {
			var binary_string = window.atob(base64);
			var len = binary_string.length;
			var bytes = new Uint8Array(len);
			for (var i = 0; i < len; i++) {
				bytes[i] = binary_string.charCodeAt(i);
			}
			return bytes.buffer;
		};
    };
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/Base64Util.js
// module id = 56
// module chunks = 6